import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import axios from "axios";
import {privateApiLongTimeout, publicApi} from "../api";

function Login() {
    localStorage.removeItem("focus")
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const checkServices = async () => {
        try {
            await privateApiLongTimeout.get("/cr-whatsapp-selenium-service/whatsapp/status")
        } catch (err) {
            if (axios.isAxiosError(err)) {
                toast.warning("Servizio WhatsApp non configurato")
            }
        }
    }

    const handleLogin = async (event: React.SubmitEvent<HTMLFormElement>) => {
        event.preventDefault();

        const basicAuth: string = btoa(`${email}:${password}`);

        try {
            const res = await publicApi.post(
                "/v1/auth/token",
                {},
                {
                    headers: {
                        Authorization: `Basic ${basicAuth}`,
                    },
                }
            );

            const token = res.data.accessToken;
            const refresh = res.data.refreshToken;
            localStorage.setItem("accessToken", token);
            localStorage.setItem("refreshToken", refresh);
            // localStorage.setItem("focus", "ordini");
            navigate("/order");
            toast.success("Login eseguito con successo");
            checkServices();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }
    return (
        <div className="bg-blue-50 flex items-center justify-center min-h-screen">
            <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md">
                {/*Title*/}
                <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">
                    Casablanca Riparazioni
                </h2>

                {/*Form*/}
                <form className="space-y-5"
                      onSubmit={handleLogin}>

                    {/*Email*/}
                    <div>
                        <label className="block text-gray-600 mb-1">Username o Email</label>
                        <input placeholder="you@example.com"
                               className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                               onChange={(event) => setEmail(event.target.value)}/>
                    </div>

                    {/*Password*/}
                    <div>
                        <label className="block text-gray-600 mb-1">Password</label>
                        <input type="password" placeholder="••••••••"
                               className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                               onChange={(event) => setPassword(event.target.value)}/>
                    </div>

                    {/*Options*/}
                    <div className="flex items-center justify-between text-sm">
                        <Link to={"/resetPassword"} className="text-blue-600 hover:underline">Password
                            dimenticata?</Link>
                    </div>

                    {/*Button*/}
                    <button type="submit"
                            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200">
                        Login
                    </button>

                </form>
            </div>
        </div>
    )
}

export default Login;